<template>
  <div class="form-area scroll-fire-fox">
    <slot name="fields" />

    <div class="buttons-container">
      <management-button
        v-if="generateButton"
        :label="$t('GenerateFile')"
        type="execute"
        :disabled="
          buttonsDisabled || !userHasManagementPermission('export_store')
        "
        style="margin: 10px 0"
        @buttonClick="generateReport"
      />
    </div>

    <slot name="customButton" />
  </div>
</template>

<script>
import { bus } from "@/main.js";
import { mapActions } from "vuex";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import ManagementTableButton from "../../../../../Management/ManagementTableButton";
import ManagementButton from "../../../../../Management/ManagementButton";

export default {
  name: "ReportFormArea",

  components: {
    ManagementButton,
    ManagementTableButton
  },

  mixins: [checkPermissionsMixin],

  props: {
    buttonsDisabled: {
      type: Boolean,
      required: true
    },

    generateButton: {
      type: Boolean,
      default: true
    },

    dataToSend: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions(["CREATE_EXPORT"]),

    generateReport() {
      this.CREATE_EXPORT(this.dataToSend)
        .then(newReport => {
          bus.$emit("add-home-report-file-to-list", newReport);
        })
        .catch(error => console.error(error));
    }
  }
};
</script>

<style scoped>
.form-area {
  height: 100%;
  min-width: 300px;
  width: 300px;
  display: flex;
  padding-top: 10px;
  padding-right: 20px;
  margin-right: 20px;
  flex-direction: column;
  overflow-y: auto;
}
.form-area .buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Reports/Form/FormArea.vue